import { PLAIN_JSON_TYPES } from '../constants/apiLogDetail'

/** Pretty-print JSON strings and objects. Leave other text as stored. */
export function formatApiLogBody(value: unknown): string {
  if (value == null || value === '') return '—'
  if (typeof value === 'string') {
    if (value.trim() === '') return '—'
    try {
      return JSON.stringify(JSON.parse(value), null, 2)
    } catch {
      return value
    }
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }
  try {
    return JSON.stringify(value, null, 2)
  } catch {
    return String(value)
  }
}

/**
 * Credit-Report and Paypal responses stay raw strings (Angular string view).
 * Other types are unserialized by the API and come back as objects.
 */
export function formatApiLogResponseBody(apiType: string | undefined, value: unknown): string {
  if (value == null || value === '') return '—'
  if (PLAIN_JSON_TYPES.has(apiType ?? '') && typeof value === 'string') {
    return value.trim() === '' ? '—' : value
  }
  return formatApiLogBody(value)
}
